const language = {
	spanish: {
		title:
			"Desarrollando soluciones de tracking GPS y software de seguimiento de flotas desde 1998",
		oficina_1_title: "Oficina Caracas:",
		oficina_2_title: "Oficina Miami:",
		form_title: "Deseamos ayudarte, contáctanos ahora:",
		form_fields: [
			{
				title: "Nombre",
				requestKey: "nombre_apellido",
			},
			{
				title: "Email",
				requestKey: "email",
			},
			{
				title: "País",
				requestKey: "pais",
			},
			{
				title: "Apellido",
				requestKey: "apellido",
			},
			{
				title: "Móvil",
				requestKey: "movil",
			},
			{
				title: "Empresa",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "¿Cómo se enteró de nosotros? *Opcional. ",
				requestKey: "como_se_entero",
			},
		],
		form_button_text: "ENVÍA TU RESUMEN",
	},
	english: {
		title:
			"Developing GPS tracking solutions and fleet tracking software since 1998",
		oficina_1_title: "Caracas office:",
		oficina_2_title: "Miami office:",
		form_title: "We want to help you, contact us now:",
		form_fields: [
			{
				title: "Name",
				requestKey: "nombre_apellido",
			},
			{
				title: "Email",
				requestKey: "email",
			},
			{
				title: "Country",
				requestKey: "pais",
			},
			{
				title: "Last Name",
				requestKey: "apellido",
			},
			{
				title: "Mobile",
				requestKey: "movil",
			},
			{
				title: "Company",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "¿How did you hear about us? *Optional. ",
				requestKey: "como_se_entero",
			},
		],
		form_button_text: "SEND YOUR SUMMARY",
	},
};

export default language;